import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Fai } from '@bytel/bytel-sales';
import { ConfigurationService, LimitedCommercialSeries, RangesNewGeneration } from '@bytel/checkout';

import { AppService } from '@services/app.services';
import { MainCartService } from '@services/main-cart.service';
import { PrismeLoggerService } from '@services/prisme-logger.service';

import { ModalComponent } from '../modal/modal.component';

@Component({
    selector: 'checkout-ftth-eligibility-error-modal',
    standalone: true,
    imports: [CommonModule, ModalComponent],
    templateUrl: './ftth-eligibility-error-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FtthEligibilityErrorModalComponent extends ModalComponent {
    public title: string = 'Quelque chose nous empêche de finaliser cette commande';
    public canCallBack: boolean = true;

    protected appService: AppService = inject(AppService);
    protected configService: ConfigurationService = inject(ConfigurationService);
    protected cartService: MainCartService = inject(MainCartService);
    protected prismeLogger: PrismeLoggerService = inject(PrismeLoggerService);

    public ngOnInit(): void {
        try {
            this.prismeLogger.sendLogToPrisme('Affichage_modale_erreur_perte_eligibilite_ftth', null);
        } catch (error) {
            console.log(error);
        }

        const currentOffer = this.cartService.getQuoteFai().getPrincipalProduct<Fai>(Fai);
        if (
            currentOffer.data.commercial_series === LimitedCommercialSeries.B_AND_YOU ||
            currentOffer.data.range_ng === RangesNewGeneration.VERY_FIT
        ) {
            this.canCallBack = false;
        }
    }

    public redirect(): void {
        this.resetAndRedirect();
    }

    public redirectToStore(): void {
        this.resetAndRedirect();
    }

    public retry(): void {
        this.modalRef.close();
    }

    private resetAndRedirect(redirectUrl: string = this.configService.getData().global.wall.store): void {
        try {
            this.cartService.reset();
            this.cartService.addQuote();
            this.cartService.save();
            this.appService.navigateTo(redirectUrl);
        } catch (error) {
            this.appService.navigateTo(redirectUrl);
        }
    }
}
